import { render, staticRenderFns } from "./tab-inquiry.vue?vue&type=template&id=549bb20e&scoped=true"
import script from "./tab-inquiry.vue?vue&type=script&lang=js"
export * from "./tab-inquiry.vue?vue&type=script&lang=js"
import style0 from "./tab-inquiry.vue?vue&type=style&index=0&id=549bb20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549bb20e",
  null
  
)

export default component.exports